export const TOP_DISK_MARGIN = 150;
export const MAX_DISK_HEIGHT = 50;
export const MIN_DISK_WIDTH_INCREMENT = 50;
export const MS_IN_SECOND = 1000;
